export const FB_PIXEL_ID = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID;

// The Meta Pixel script (fbevents.js) is only loaded once the visitor accepts
// cookies: nothing to download or run for visitors who haven't (see _app.js).
export const loadPixel = () => {
    if (typeof window === 'undefined' || window.fbq || !FB_PIXEL_ID) return;
    /* eslint-disable */
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq('init', FB_PIXEL_ID);
    window.fbq('track', 'PageView');
};

export const pageview = () => {
    if (!window.fbq) return;
    window.fbq('track', 'PageView');
};

export const event = (name, options = {}) => {
    if (!window.fbq) return;
    window.fbq('track', name, options);
};
